import { useApp } from '@/context/AppContext';

interface KpiCardProps {
  title: string;
  value: string;
  icon: string;
  iconBg: string;
  iconColor: string;
  trend?: { value: string; positive: boolean };
  subtitle?: string;
}

export default function KpiCard({ title, value, icon, iconBg, iconColor, trend, subtitle }: KpiCardProps) {
  const { isDark } = useApp();

  return (
    <div className={`rounded-xl p-5 border transition-all
      ${isDark ? 'bg-gray-900 border-gray-800' : 'bg-white border-gray-100'}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className={`text-xs font-medium uppercase tracking-wide mb-1 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            {title}
          </p>
          <p className={`text-2xl font-bold truncate ${isDark ? 'text-white' : 'text-gray-900'}`}>
            {value}
          </p>
          {subtitle && (
            <p className={`text-xs mt-1 ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>{subtitle}</p>
          )}
          {trend && (
            <div className={`flex items-center gap-1 mt-2 text-xs font-medium
              ${trend.positive ? 'text-emerald-500' : 'text-red-500'}`}>
              <span className="w-3 h-3 flex items-center justify-center">
                <i className={trend.positive ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} />
              </span>
              {trend.value}
            </div>
          )}
        </div>
        <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 ml-3 ${iconBg}`}>
          <span className="w-6 h-6 flex items-center justify-center">
            <i className={`${icon} text-xl ${iconColor}`} />
          </span>
        </div>
      </div>
    </div>
  );
}
